//-----------------------------------------------------------------------
export default {
    install (Vue, options) {  
        let leseapp = { 
            'useads': (process.env.VUE_APP_USE_ADS=='1' ? true : false), 
            'detail_picindex': process.env.VUE_APP_DETAIL_PICINDEX
        };

        Vue.prototype.$mode      = process.env.VUE_APP_ENV_MODE;
        Vue.prototype.$serverKey = process.env.VUE_APP_PUSH_SERVER_KEY;
        Vue.prototype.$leseapp   = leseapp;
    }
}